module.exports = {
  PRIMARY_DATA: require('./primaryData'),
  SECONDARY_DATA: require('./secondaryData'),
  FEES_RETAILER: require('./feesData').FEES_RETAILER,
  FEES_CUSTOMER: require('./feesData').FEES_CUSTOMER,
  CHARGEBACK_DATA: require('./chargebackData')
}
